module.exports = __webpack_public_path__ + "static/img/40.70fe6c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40.png
// module id = aDuS
// module chunks = 1